import AcknowledgeCancellation from "../symbols/acknowledgeCancellation";

import { HttpRequestPost } from "../../service";
const acknowledgeCancellationAction = () => ({
  type: AcknowledgeCancellation.ACKNOWLEDGE_CANCELLATION,
});
const acknowledgeCancellationSuccessAction = (data: any) => ({
  type: AcknowledgeCancellation.ACKNOWLEDGE_CANCELLATION_SUCCESS,
  payload: data,
});
const acknowledgeCancellationFailureAction = (data: any) => ({
  type: AcknowledgeCancellation.ACKNOWLEDGE_CANCELLATION_FAILURE,
  payload: data,
});
const clearAcknowledgeCancellationAction = () => ({
  type: AcknowledgeCancellation.CLEAR_ACKNOWLEDGE_CANCELLATION,
});

export function getAcknowledgeCancellation(id: string, acknowledgeId: string) {
  const url = `/customer/delivery/${id}/acknowledge-cancellation-request/${acknowledgeId}`;
  return (dispatch: any) => {
    dispatch(acknowledgeCancellationAction());
    HttpRequestPost(
      url,
      dispatch,
      acknowledgeCancellationSuccessAction,
      acknowledgeCancellationFailureAction,
      true,
      {}
    );
  };
}

export function clearAcknowledgeCancellation() {
  return (dispatch: any) => {
    dispatch(clearAcknowledgeCancellationAction());
  };
}
